import { combineReducers } from "redux";
import { reducer as notifications } from "react-notification-system-redux";
import loginReducer from "./login.reducer";
import toastReducer from "./toast.reducer";
import roleListReducer from "./roleList.reducer";
import roleViewReducer from "./roleView.reducer";
import createShippingOrderReducer from "./createShippingOrder.reducer";
import userListReducer from "./userList.reducer";
import userViewReducer from "./userView.reducer";
import permissionsReducer from "./permissions.reducer";
import productListReducer from "./productList.reducer";
import productViewReducer from "./productView.reducer";
import productCategoryListReducer from "./productCategoryList.reducer";
import productBrandListReducer from "./productBrandList.reducer";
import ds1BrandListReducer from "./ds1BrandList.reducer";
import ds1CatalogueListReducer from "./ds1CatalogueList.reducer";
import ds1ProductListReducer from "./ds1ProductList.reducer";
import ds1ProductFiltersReducer from "./ds1ProductFilters.reducer";
import ds1AllProductsReducer from "./ds1AllProducts.reducer";
import ds1AllProductFiltersReducer from "./ds1AllProductFilters.reducer";
import ds1ProductVariantOverviewReducer from "./ds1ProductVariantOverview.reducer";
import productUnitListReducer from "./productUnitList.reducer";
import productPackagingListReducer from "./productPackagingList.reducer";
import productCategoryViewReducer from "./productCategoryView.reducer";
import productBrandViewReducer from "./productBrandView.action";
import productUnitViewReducer from "./productUnitView.reducer";
import productPackagingViewReducer from "./productPackagingView.reducer";
import shelfLifeListReducer from "./shelfLifeList.reducer";
import productStatusListReducer from "./productStatusList.reducer";
import warehouseListReducer from "./warehouseList.reducer";
import warehouseViewReducer from "./warehouseView.reducer";
import statesCitiesDataReducer from "./stateCitiesData.reducer";
import zoneListReducer from "./zoneList.reducer";
import zoneViewReducer from "./zoneView.reducer";
import franchiseListReducer from "./franchiseList.reducer";
import franchiseViewReducer from "./franchiseView.reducer";
import inventoryReducer from "./inventory.reducer";
import deliveryPartnerListReducer from "./deliveryPartnerList.reducer";
import deliveryPartnerViewReducer from "./deliveryPartnerView.reducer";
import storeListReducer from "./storeList.reducer";
import storeViewReducer from "./storeView.reducer";
import shippingListReducer from "./shippingList.reducer";
import shippingViewReducer from "./shippingView.reducer";
import vmListReducer from "./vmList.reducer";
import vmViewReducer from "./vmView.reducer";
import paymentTypesReducer from "./paymentTypes.reducer";
import refillListReducer from "./refillList.reducer";
import storeInventoryReducer from "./storeInventory.reducer";
import deliveryPersonListReducer from "./deliveryPersonList.reducer";
import deliveryPersonViewReducer from "./deliveryPersonView.reducer";
import refillViewReducer from "./refillView.reducer";
import dashboardReducer from "./dashboard.reducer";
import orderListReducer from "./orderList.reducer";
import orderViewReducer from "./orderView.reducer";
import meReducer from "./me.reducer";
import vmFeedbacksReducer from "./vmfeedback.reducer";
import productFeedbackReducer from "./productFeedback.reducer";
import productRequestsReducer from "./productRequest.reducer";
import cancelConfirmReducer from "./cancelConfirm.reducer";
import collapseSidebarReducer from "./collapseSidebar.reducer";
import notificationsReducer from "./notifications.reducer";
import salesAnalyticsReducer from "./salesAnalytics.reducer";
import couponListReducer from "./couponList.reducer";
import planogramListByVMTemplateReducer from "./getPlanogramListByVMTemplate.reducer";
import couponViewReducer from "./couponView.reducer";
import discountListReducer from "./discountList.reducer";
import discountViewReducer from "./discountView.reducer";
import subOfferViewReducer from "./subofferView.reducer";
import modalsReducer from "./modals.reducer";
import savedSalesTemplateReducer from "./savedSalesTemplate.reducer";
import savedSalesReportReducer from "./savedSalesReport.reducer";
import defaultSalesTemplateReducer from "./defaultSalesTemplate.reducer";
import userProductCategoryListReducer from "./userProductCategoryList.reducer";
import purchaseOrderViewReducer from "./purchaseOrderView.reducer";
import purchaseOrderListReducer from "./purchaseOrderList.reducer";
import purchaseReturnOrderListReducer from "./purchaseReturnOrderList.reducer";
import { LOG_OUT } from "../../constants/action.constants";
import supplierListReducer from "./supplierList.reducer";
import supplierViewReducer from "./supplierView.reducer";
import storeManagerListReducer from "./storeManagerList.reducer";
import storeManagerViewReducer from "./storeManagerView.reducer";
import vmTemplateListReducer from "./vmTemplateList.reducer";
import vmTemplateViewReducer from "./vmTemplateView.reducer";
import bulkRefillListReducer from "./bulkRefillList.reducer";
import bulkRefillViewReducer from "./bulkRefillView.reducer";
import vmSettingsListReducer from "./vmSettingsList.reducer";
import vmSettingsViewReducer from "./vmSettingsView.reducer";
import vmBrandModelListReducer from "./vmBrandModelList.reducer";
import networkDeviceTypeListReducer from "./networkDeviceTypeList.reducer";
import vmTypeListReducer from "./vmTypeList.reducer";
import carrierBoardListReducer from "./carrierBoardList.reducer";
import transactionReportColumnsListReducer from "./transactionReportColumns.reducer";
import refundReasonListReducer from "./refundReasonList.reducer";
import refundableItemsListReducer from "./refundableItemsList.reducer";
import planogramTemplateListReducer from "./planogramTemplateList.reducer";
import planogramTemplateViewReducer from "./planogramTemplateView.reducer";
import returnOrderList from "./returnOrderList.reducer";
import returnOrderViewReducer from "./returnOrderView.reducer";
import refillPartnerListReducer from "./refillPartnerList.reducer";
import refillPartnerViewReducer from "./refillPartnerView.reducer";
import hardwareBoardListReducer from "./hardwareBoard.reducer";
import deletedVMListReducer from "./deletedVMList.reducer";
import vendingMachineTagsReducer from "./vendingMachineTags.reducer";
import storeReturnOverviewReducer from "./storeReturnOverview.reducer";
import storeReturnOrderViewReducer from "./storeReturnOrderView.reducer";
import brandListReducer from "./brandList.reducer";
import reportListReducer from "./reportList.reducer";
import reportViewReducer from "./reportView.reducer";
import retailersListReducer from "./retailersList.reducer";
import retailerViewReducer from "./retailerView.reducer";
import warehouseOrderListReducer from "./warehouseOrderList.reducer";
import materialTransferView from "./materialTransferView.reducer";
import discardedBinReducer from "./discardedBin.reducer";
import tallyInventoryReducer from "./tallyInventory.reducer";
import supplierReturnReducer from "./supplierReturn.reducer";
import cashOrderViewReducer from "./cashOrderView.reducer";
import cashOrderDetailsReducer from "./cashOrderDetails.reducer";
import customerFeedbackListReducer from "./customerFeedbackList.reducer";
import advertisementViewReducer from "./advertisementView.reducer";
import advertisementListReducer from "./advertisementList.reducer";
import analyticsReducer from "./analytics.reducer";
import manufacturersListReducer from "./manufacturersList.reducer";
import modelsListReducer from "./modelList.reducer";
import warehouseVisibilityRetailersListReducer from "./warehouseVisibilityRetailerList.reducer";
import customerPlatformListReducer from "./customerPlatformList.reducer";
import restrictedProductListReducer from "./restrictedProductList.reducer";
import negativeItemListReducer from "./negativeItemList.reducer";
import negativeItemViewReducer from "./negativeItemView.reducer";
import requestProductViewReducer from "./requestProductView.reducer";
import refillerPermissionListReducer from "./refillerPermissionList.reducer";
import kitTransferReducer from "./kitTransferView.reducer";
import vmStockAvailabilityReducer from "./vmStockAvailability.reducer";
import purchaseApprovalAdminListReducer from "./purchaseApprovalAdminList.reducer";
import saleOrderView from "./saleOrderView.reducer";
import directSaleListReducer from "./directSaleList.reducer";
import requestOrderView from "./requestOrderView.reducer";
import topUpViewReducer from "./topupView.reducer";
import cashCollectionView from "./cashCollectionView.reducer";
import offerDestinationListReducer from "./offerDestinationList.reducer";
import offerTypesListReducer from "./offerTypesList.reducer";
import purchaseReturnViewReducer from "./purchaseReturnOrderView.reducer";
import vmTemplateListDropdownReducer from "./vmTemplateListDropdown.reducer";
import pgModuleViewReducer from "./pgModuleView.reducer";
import refillerNotificationListReducer from "./refillerNotificationList.reducer";
import actionHistoryListReducer from "./actionHistoryList.reducer";
import refillListFilterReducer from "./refillListFilter.reducer";
import warehouseListFilterReducer from "./warehouseListFilter.reducer";
import warehouseOrderListFilterReducer from "./warehouseOrderListFilter.reducer";
import purchaseOrderListFilterReducer from "./purchaseOrderListFilter.reducer";
import actionHistoryListFilterReducer from "./actionHistoryListFilter.reducer";
import orderListFilterReducer from "./orderListFilter.reducer";
import masterDataList from "./masterDataList.reducer";
import technicianPartnerListReducer from "./technicianPartnerList.reducer";
import technicianPartnerViewReducer from "./technicianPartnerView.reducer";
import technicianTransactionListReducer from "./technicianTransactionList.reducer";
import incidentListReducer from "./incidentList.reducer";
import incidentTypeListReducer from "./incidentTypeList.reducer";
import jobListReducer from "./jobList.reducer";
import jobViewReducer from "./jobView.reducer";
import technicianPermissionListReducer from "./technicianPermissionList.reducer";
import technicianNotificationListReducer from "./technicianNotificationList.reducer";
import technicianLogsReducer from "./technicianLogs.reducer";
import motorActionLogsReducer from "./motorActionLogs.reducer";
import motorLogViewReducer from "./motorLogView.reducer";
const appReducer = combineReducers({
  notifications,
  loginReducer,
  toastReducer,
  roleListReducer,
  roleViewReducer,
  userListReducer,
  userViewReducer,
  permissionsReducer,
  productListReducer,
  productViewReducer,
  productCategoryListReducer,
  productBrandListReducer,
  ds1BrandListReducer,
  ds1CatalogueListReducer,
  ds1ProductListReducer,
  ds1ProductFiltersReducer,
  ds1AllProductsReducer,
  ds1AllProductFiltersReducer,
  ds1ProductVariantOverviewReducer,
  productUnitListReducer,
  productPackagingListReducer,
  productCategoryViewReducer,
  productBrandViewReducer,
  productUnitViewReducer,
  productPackagingViewReducer,
  shelfLifeListReducer,
  productStatusListReducer,
  warehouseListReducer,
  warehouseViewReducer,
  statesCitiesDataReducer,
  zoneListReducer,
  zoneViewReducer,
  deliveryPartnerListReducer,
  deliveryPartnerViewReducer,
  franchiseListReducer,
  franchiseViewReducer,
  storeListReducer,
  storeViewReducer,
  shippingListReducer,
  shippingViewReducer,
  vmListReducer,
  vmViewReducer,
  paymentTypesReducer,
  refillListReducer,
  storeInventoryReducer,
  deliveryPersonListReducer,
  deliveryPersonViewReducer,
  refillViewReducer,
  dashboardReducer,
  orderListReducer,
  orderViewReducer,
  meReducer,
  vmFeedbacksReducer,
  productFeedbackReducer,
  productRequestsReducer,
  inventoryReducer,
  cancelConfirmReducer,
  collapseSidebarReducer,
  notificationsReducer,
  salesAnalyticsReducer,
  couponListReducer,
  couponViewReducer,
  discountListReducer,
  discountViewReducer,
  modalsReducer,
  savedSalesTemplateReducer,
  savedSalesReportReducer,
  defaultSalesTemplateReducer,
  userProductCategoryListReducer,
  purchaseOrderListReducer,
  purchaseOrderViewReducer,
  supplierListReducer,
  supplierViewReducer,
  storeManagerListReducer,
  storeManagerViewReducer,
  vmTemplateListReducer,
  vmTemplateViewReducer,
  bulkRefillViewReducer,
  bulkRefillListReducer,
  vmSettingsViewReducer,
  vmSettingsListReducer,
  vmBrandModelListReducer,
  networkDeviceTypeListReducer,
  vmTypeListReducer,
  carrierBoardListReducer,
  transactionReportColumnsListReducer,
  refundReasonListReducer,
  refundableItemsListReducer,
  planogramTemplateListReducer,
  planogramTemplateViewReducer,
  returnOrderList,
  returnOrderViewReducer,
  refillPartnerListReducer,
  refillPartnerViewReducer,
  technicianPartnerListReducer,
  technicianPartnerViewReducer,
  technicianTransactionListReducer,
  planogramListByVMTemplateReducer,
  hardwareBoardListReducer,
  deletedVMListReducer,
  vendingMachineTagsReducer,
  storeReturnOverviewReducer,
  storeReturnOrderViewReducer,
  brandListReducer,
  reportListReducer,
  reportViewReducer,
  retailersListReducer,
  retailerViewReducer,
  warehouseOrderListReducer,
  discardedBinReducer,
  tallyInventoryReducer,
  supplierReturnReducer,
  createShippingOrderReducer,
  materialTransferView,
  cashOrderViewReducer,
  cashOrderDetailsReducer,
  customerFeedbackListReducer,
  advertisementViewReducer,
  advertisementListReducer,
  analyticsReducer,
  manufacturersListReducer,
  modelsListReducer,
  warehouseVisibilityRetailersListReducer,
  customerPlatformListReducer,
  restrictedProductListReducer,
  negativeItemListReducer,
  negativeItemViewReducer,
  refillerPermissionListReducer,
  requestProductViewReducer,
  kitTransferReducer,
  vmStockAvailabilityReducer,
  purchaseApprovalAdminListReducer,
  saleOrderView,
  directSaleListReducer,
  requestOrderView,
  topUpViewReducer,
  cashCollectionView,
  offerDestinationListReducer,
  offerTypesListReducer,
  subOfferViewReducer,
  purchaseReturnOrderListReducer,
  purchaseReturnViewReducer,
  vmTemplateListDropdownReducer,
  pgModuleViewReducer,
  refillerNotificationListReducer,
  actionHistoryListReducer,
  refillListFilterReducer,
  warehouseListFilterReducer,
  warehouseOrderListFilterReducer,
  purchaseOrderListFilterReducer,
  actionHistoryListFilterReducer,
  orderListFilterReducer,
  masterDataList,
  incidentListReducer,
  incidentTypeListReducer,
  jobListReducer,
  jobViewReducer,
  technicianPermissionListReducer,
  technicianNotificationListReducer,
  technicianLogsReducer,
  motorActionLogsReducer, 
  motorLogViewReducer,
});

//Root reducer is used to revert back all reducers state to the initial state when user logs out.
const rootReducer = (state, action) => {
  if (action.type === LOG_OUT) {
    //All reducers return initial state when state not passed
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
